<mat-form-field [formGroup]="formGroup" class="filter-field" color="primary" appearance="outline">
  <input matInput
         (keypress)="dateFormatFilter($event)"
         [matDatepicker]="picker"
         autocomplete="off"
         [formControlName]="column.filterName"
         maxlength="10">
  <mat-datepicker-toggle matSuffix [for]="picker" tabIndex="-1"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
